import React from "react";
import { progress } from "../helpers/reviewItems";
import { ScopeReview } from "../types";
import useStyles from "../styles/useStyles";

const GradeCard: React.FC<{ review: ScopeReview }> = ({ review }) => {
  const styles = useStyles();
  const { done, total } = progress(review);
  const pct = total === 0 ? 100 : Math.round((done / total) * 100);
  return (
    <div className={styles.gradeCard}>
      <div className={styles.gradeLetter}>{review.grade}</div>
      <div className={styles.gradeBody}>
        <div className={styles.score}>{`${review.score} / 100`}</div>
        <div>{review.summary}</div>
        <div
          className={styles.progressTrack}
          role="progressbar"
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          <div className={styles.progressFill} style={{ width: `${pct}%` }} />
        </div>
        <small>{`${done} of ${total} to-dos done`}</small>
      </div>
    </div>
  );
};

export default GradeCard;
